import {
  PayrollOverviewDetailsGetters,
  PayrollOverviewDetailsActions,
  PayrollOverviewDetailsMutations
} from '@/app/features/payroll-overviews/features/payroll-overviews-details/payroll-overview-details.keys';
import { payrollOverviewDetailsService } from '@/app/features/payroll-overviews/features/payroll-overviews-details/payroll-overview-details.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import { TolMessagesActions } from '@/app/features/tol-messages/tol-messages.keys';

export const getInitialState = () => {
  return {
    payrollOverviewDetailsLoading: true,
    payrollOverviewDetails: {},
    payrollOverviewTimesheetsLoading: true,
    payrollOverviewTimesheets: [],
    payrollOverviewTimesheetsCount: 0,
    payrollOverviewTimesSheetSortOrder: {
      sortBy: 'startDate',
      sortDirection: 'desc'
    },
    payrollOverviewTimeSheetsPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    }
  };
};

export const payrollOverviewDetailsStore = {
  state: getInitialState(),
  getters: {
    [PayrollOverviewDetailsGetters.PayrollOverviewDetails]: state => state.payrollOverviewDetails,
    [PayrollOverviewDetailsGetters.PayrollOverviewDetailsIsLoading]: state =>
      state.payrollOverviewDetailsLoading,
    [PayrollOverviewDetailsGetters.PayrollOverviewTimesheets]: state =>
      state.payrollOverviewTimesheets,
    [PayrollOverviewDetailsGetters.PayrollOverviewTimesheetsCount]: state =>
      state.payrollOverviewTimesheetsCount,
    [PayrollOverviewDetailsGetters.PayrollOverviewTimesheetsIsLoading]: state =>
      state.payrollOverviewTimesheetsLoading,
    [PayrollOverviewDetailsGetters.PayrollOveriewTimeSheetsSortOrder]: state =>
      state.payrollOverviewTimesSheetSortOrder,
    [PayrollOverviewDetailsGetters.PayrollOveriewTimeSheetsPerPage]: state =>
      state.payrollOverviewTimeSheetsPaginationParameters.recordsPerPage,
    [PayrollOverviewDetailsGetters.PayrollOveriewTimeSheetsListingOffset]: state =>
      state.payrollOverviewTimeSheetsPaginationParameters.offset
  },
  mutations: {
    [PayrollOverviewDetailsMutations.SetPayrollOverviewDetailsLoading]: (state, loading = true) => {
      state.payrollOverviewDetailsLoading = loading;
    },
    [PayrollOverviewDetailsMutations.SetPayrollOverviewDetails]: (state, pod) => {
      state.payrollOverviewDetails = pod;
    },
    [PayrollOverviewDetailsMutations.SetPayrollOverviewTimesheets]: (state, timesheets) => {
      state.payrollOverviewTimesheets = timesheets;
    },
    [PayrollOverviewDetailsMutations.SetPayrollOverviewTimesheetsLoading]: (
      state,
      loading = true
    ) => {
      state.payrollOverviewTimesheetsLoading = loading;
    },
    [PayrollOverviewDetailsMutations.SetPayrollOverviewTimeSheetsSortOrder]: (state, sortOrder) => {
      state.payrollOverviewTimesSheetSortOrder = sortOrder;
    },
    [PayrollOverviewDetailsMutations.SetPayrollOverviewTimesheetsCount]: (state, count) => {
      state.payrollOverviewTimesheetsCount = count;
    },
    [PayrollOverviewDetailsMutations.UpdatePayrollOverviewimeSheetsPaginationParameters]: (
      state,
      params
    ) => {
      state.payrollOverviewTimeSheetsPaginationParameters.recordsPerPage = params.recordsPerPage;
      state.payrollOverviewTimeSheetsPaginationParameters.offset = params.offset;
    },
    [PayrollOverviewDetailsMutations.ResetPayrollOverviewTimeSheetsPaginationOffset]: state => {
      state.payrollOverviewTimeSheetsPaginationParameters.offset = 0;
    }
  },
  actions: {
    [PayrollOverviewDetailsActions.RetrievepayrollOverviewDetails]: (
      { dispatch, commit },
      referenceNumber
    ) => {
      commit(PayrollOverviewDetailsMutations.SetPayrollOverviewDetailsLoading);
      return payrollOverviewDetailsService
        .retrievePayrollOverviewDetails(referenceNumber)
        .then(result => {
          dispatch(
            PayrollOverviewDetailsActions.RetrievePayrollOverviewTimesheets,
            referenceNumber
          );
          dispatch(
            PayrollOverviewDetailsActions.RetrievePayrollOverviewTimesheetsCount,
            referenceNumber
          );
          commit(PayrollOverviewDetailsMutations.SetPayrollOverviewDetails, result);
        })
        .then(() => {
          commit(PayrollOverviewDetailsMutations.SetPayrollOverviewDetailsLoading, false);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, { error });
        });
    },
    [PayrollOverviewDetailsActions.RetrievePayrollOverviewTimesheets]: (
      { state, commit, dispatch },
      referenceNumber
    ) => {
      commit(PayrollOverviewDetailsMutations.SetPayrollOverviewTimesheetsLoading);

      return payrollOverviewDetailsService
        .retrievePayrollOverviewTimesheets(
          referenceNumber,
          state.payrollOverviewTimesSheetSortOrder,
          state.payrollOverviewTimeSheetsPaginationParameters
        )
        .then(result => {
          commit(PayrollOverviewDetailsMutations.SetPayrollOverviewTimesheets, result);
        })
        .then(() => {
          commit(PayrollOverviewDetailsMutations.SetPayrollOverviewTimesheetsLoading, false);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, { error });
        });
    },
    [PayrollOverviewDetailsActions.RetrievePayrollOverviewTimesheetsCount]: (
      { commit, dispatch },
      referenceNumber
    ) => {
      return payrollOverviewDetailsService
        .retrievePayrollOverviewTimesheetsCount(referenceNumber)
        .then(result => {
          commit(PayrollOverviewDetailsMutations.SetPayrollOverviewTimesheetsCount, result);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, { error });
        });
    },

    [PayrollOverviewDetailsActions.SetPayrollOverviewTimeSheetsSortOrder]: (
      { state, commit, dispatch },
      sortOrder
    ) => {
      commit(PayrollOverviewDetailsMutations.SetPayrollOverviewTimeSheetsSortOrder, sortOrder);
      dispatch(
        PayrollOverviewDetailsActions.RetrievePayrollOverviewTimesheets,
        state.payrollOverviewDetails.reference_number
      );
    },
    [PayrollOverviewDetailsActions.SetPayrollOverviewTimeSheetsPaginationParameters]: (
      { state, commit, dispatch },
      params
    ) => {
      commit(
        PayrollOverviewDetailsMutations.UpdatePayrollOverviewimeSheetsPaginationParameters,
        params
      );
      dispatch(
        PayrollOverviewDetailsActions.RetrievePayrollOverviewTimesheets,
        state.payrollOverviewDetails.reference_number
      );
    },
    [PayrollOverviewDetailsActions.ProcessPayrollOverviewResults]: (
      { state, dispatch },
      fileName
    ) => {
      return payrollOverviewDetailsService
        .processResults(state.payrollOverviewDetails.reference_number, fileName)
        .then(status => {
          if (status.status && status.status !== 201) {
            dispatch(TolErrorsActions.SetError, { message: status.message });
          } else {
            dispatch(TolMessagesActions.SetMessages, { text: status.message, type: 'success' });
            dispatch(
              PayrollOverviewDetailsActions.RetrievepayrollOverviewDetails,
              state.payrollOverviewDetails.reference_number
            );
          }
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, { error });
        });
    }
  }
};
